/* eslint-disable */
import { catFetchPost } from './base/catFetchClient';
import { UserWeeklyLog } from './getUserWeeklyLog';

export const saveEntries = async (userWeeklyLog: Array<UserWeeklyLog>) => {
    return await catFetchPost('weeklylog/saveentries', userWeeklyLog);
}